import { CardType } from 'types/deck'
import { Option } from 'components/elements/ArchidektDropdown/types'

import ArchidektDropdown from 'components/elements/ArchidektDropdown'
import PhatButton from 'components/formElements/PhatButton'

import styles from './oTagQuickOptions.module.scss'

type Props = {
  card: CardType
  disabled?: boolean
}

const OTagQuickOptions = ({ card, disabled }: Props) => {
  const options: Option[] = []

  const tagToOption = (tagName: string): Option => ({ label: tagName, onClick: () => null, className: styles.tag })

  if (card.oTags.length) {
    options.push({ type: 'header', label: 'Oracle tags' })
    options.push({ type: 'spacer' })
    options.push(...card.oTags.map(tagToOption))
  }

  if (card.inheritedTags.length) {
    options.push({ type: 'spacer' })
    options.push({ type: 'header', label: 'Inherited tags' })
    options.push({ type: 'spacer' })
    options.push(...card.inheritedTags.map(tagToOption))
  }

  return (
    <ArchidektDropdown disabled={disabled} options={options} menuClassName={styles.menu}>
      <PhatButton icon="tags" className={styles.trigger} disabled={disabled}>
        Oracle tags
      </PhatButton>
    </ArchidektDropdown>
  )
}

export default OTagQuickOptions
